const doc = [({"en":({"js":({"admin":({"photo_sheet_products":({"select":({"choose_photo_sheet_product":"Choose photo sheet product"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;